import React, { useState } from "react";
import { Map, Layer, Feature } from "_c/modules/geo/Map";
import { MARKERS } from "_c/modules/geo/Map/markers";
import PT from "prop-types";
import Info from "_c/atoms/Info";
import PinIcon from "_c/icon/Pin";

const AsideMap = (props) => {
  const [show, setShow] = useState(false);
  return (
    <>
      {show ? (
        <Map lang={props.locale} center={props.coords}>
          {props.isPremium ? (
            <Layer
              key={props.id}
              type="symbol"
              id="position-premium"
              layout={{
                "icon-image": "premium",
                "icon-size": 0.15,
                "icon-ignore-placement": true,
              }}
            >
              <Feature coordinates={props.coords} />
            </Layer>
          ) : (
            <Layer
              key={props.id}
              type="circle"
              id="position"
              paint={MARKERS.secondary}
            >
              <Feature coordinates={props.coords} />
            </Layer>
          )}
        </Map>
      ) : (
        <Info
          onClick={() => setShow(true)}
          role="button"
          css={`
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            cursor: pointer;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            margin: 0;
          `}
        >
          <PinIcon width="16" color="white" />
          <span css={`
            margin-top: 5px;
            font-size: 16px; 
          `}>{props.t("common:me_on_map")}</span>
        </Info>
      )}
    </>
  );
};
AsideMap.propTypes = {
  coords: PT.array,
  isPremium: PT.bool,
  id: PT.string,

  t: PT.func.isRequired,
};
export default AsideMap;
